import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { Global } from '../classes/Global';
import { StringHelper } from '../helpers/StringHelper';

@Component({
  selector: 'app-comma-separated',
  templateUrl: './comma-separated.component.html',
  styleUrls: ['./comma-separated.component.scss']
})
export class CommaSeparatedComponent extends BaseComponent implements OnInit {

  @Input() array = [];
  @Input() type: string = "";
  @Input() key: string = "";
  @Input() label: string = "";

  constructor() {
    super();
  }

  ngOnInit() {
    
  }

  getLink(item) {
    return "/" + Global.getCountry() + "/" + Global.getStoreUrl() + "/" + Global.getMediaTypeForUrl() + "/" + 
    this.getString(this.type + "Url") + "/" + item[this.key] + "/" + StringHelper.slugify(item[this.label]).toLowerCase();
  }

}
